import { create } from 'zustand';
import type { Locales } from '@/components/ui/LocaleButton/types';

type LocaleStoreProps = {
  locale: Locales;
  changeLocale: (newLocale: Locales) => void;
};

export const useLocaleStore = create<LocaleStoreProps>((set) => ({
  locale: 'pt-BR',
  changeLocale: (newLocale) => set({ locale: newLocale })
}));
